class Document {
  constructor({
    _id,
    type,        
    url,         
    created_at,  
    user,        
  }) {
    this.id = _id;
    this.type = type;
    this.url = url;
    this.createdAt = created_at;
    this.user = user;
  }

  get tipo() {
    return this.type || "N/A";
  }

  get fechaCreacion() {
    return new Date(this.createdAt).toLocaleDateString();
  }
}
export default Document;